$(function() {
 updateCartDot(); 
});
/* Fix featured content button */
$(".image-rows-1563993316901 .text_section .cta").html("<a href='/pages/contact-locations'>Find a Store</a>");

/* Short nav and search takeover js by VMGROUPE */
var phone = false, tablet = false, waituntil = 0, isScrolling, goingUp = false, goingDown = false, fadeDelay = 333;
var w = $(window).width();

var openSearch = function() {
  $("#searchscreen").fadeIn(fadeDelay,null);
  $("body").css({"height":"100vh", "overflow":"hidden"})

  document.search.q.focus();
}
var openInquiry = function(e) {
  $("#productInquiry").fadeIn(fadeDelay,null);
  $("body").css({"height":"100vh", "overflow":"hidden"})
  document.search.q.focus();
}
var closeInquiry = function() {
	$("#productInquiry").fadeOut(fadeDelay,null);
    $("body").css({"height":"100%", "overflow":"scroll"})

}
var closeSearch = function() {
	$("#searchscreen").fadeOut(fadeDelay,null);
  	$("body").css({"height":"100%", "overflow":"scroll"})

}
var checkSize = function() {
	w = $(window).width();
	if(w <= 600){
		phone = true;
	 	tablet = false;
	}
	else if(w <= 1000 && w > 600) {
		phone = false;
	 	tablet = true;
	}
	else {
		phone = false;
		tablet = false;
	}
	if(phone || tablet) {
		$("#shopify-section-header").fadeOut(0,null);
		$("#shortnav").fadeIn(0,null);
	}
	else{
		$("#logotype-container").fadeOut(0,null);
		$("#logomark-container").fadeIn(0,null);
	}
}


$("#shopify-section-header").fadeIn(0,null);
$("#shortnav").fadeOut(0,null);
$("#logotype-container").fadeIn(0,null);
$("#logomark-container").fadeOut(0,null);
$("#searchscreen").fadeOut(0,null);
checkSize();
$("#q").focus();

window.addEventListener('resize', checkSize);
$("#search_trigger").on('click', openSearch);
$(".navsearchbutton").on('click', openSearch);
$("#productInquiryButton").on('click', openInquiry);
$("#closeInquiry").on('click', closeInquiry);
$("#closebutton").on('click', closeSearch);
document.onkeydown = function(evt) {
    evt = evt || window.event;
    if (evt.keyCode == 27) {
        closeSearch();
    }
};
$(function() {
  if(window.scrollY >= 1) {
    $("#shortnav").fadeIn(fadeDelay,null);
    $("#shopify-section-header").stop(true,true).fadeOut(fadeDelay,null);

  }
});

window.addEventListener("scroll", function(e) {
        if (this.scrollY <= 1) {
          $('body').removeClass('scrollNav');
        }
		if(this.scrollY >= waituntil){
			checkSize();
			if(phone || tablet) {
              	$("#shopify-section-header").fadeOut(0,null);
				if(this.scrollY <= 100) {
						$("#logotype-container").stop(true,true).fadeIn(fadeDelay,null);
						$("#logomark-container").stop(true,true).fadeOut(fadeDelay,null);
				}
				else {
						$("#logotype-container").stop(true,true).fadeOut(fadeDelay,null);
						$("#logomark-container").stop(true,true).fadeIn(fadeDelay,null);
					}
			}
			if(this.oldScroll > this.scrollY){ // Up
              if (this.scrollY <= 200) {
                  $('body').removeClass('scrollNav');
                }
              if (this.scrollY > 200) {
                if ($('.product-image-container').children('a').length > 1) {
                  $('body').addClass("scrollNav");
                }
                }

              if(this.scrollY >= 1) {
              	$("header.scrollheader").removeClass('scrollheader').addClass("coverheader");

              }
				checkSize();
				if(!phone && !tablet) {
						$("#shopify-section-header").fadeIn(fadeDelay,null);
						$("#shortnav").stop(true,true).fadeOut(fadeDelay,null);
				}
			}
			else if(this.scrollY >= 1){ // Down
				checkSize();
				if(!phone && !tablet) {
                  		$('body').removeClass("scrollNav");
						$("#shortnav").fadeIn(fadeDelay,null);
						$("#shopify-section-header").stop(true,true).fadeOut(fadeDelay,null);
				}
			};
			this.oldScroll = this.scrollY;
		};
});
$("header ul#main-nav li a").mouseenter(function(){
  	var scroll = $(window).scrollTop(); 
  if(scroll <= 1){
	$("header").addClass("coverheader").removeClass('scrollheader');
  }
});
$("header").mouseleave(function(){
  	var scroll = $(window).scrollTop(); 
  if(scroll <= 1){
	$("header").removeClass("coverheader").addClass('scrollheader');
  }
});

$("body").on('DOMSubtreeModified', ".CartCount", function() {
	updateCartDot();
});


// $(window).on("load", function(e) {
//   $("body").on('DOMSubtreeModified', ".topbadge", function(e) {
//       $(".wishlistUpdate").fadeIn();

//       setTimeout(function() {
//         $(".wishlistUpdate").fadeOut();
//       }, 3000);
//   });
// });